"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleOrangeBoldStyled = exports.TitleH7Styled = exports.TitleH6Styled = exports.TitleH5Styled = exports.TitleH4Styled = exports.TitleH3Styled = exports.TitleH2Styled = exports.TitleH1Styled = exports.StrapLineStyled = exports.ParagraphStyled = exports.Paragraph2Styled = exports.PageTitleStyled = exports.InfoTextStyled = exports.ErrorParagraphStyled = exports.CardTitleStyled = exports.CardTitleSmallStyled = exports.CardStrapLineStyled = exports.ActionTitleStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TitleH1Styled = _styledComponents.default.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH1.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH1.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH1.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH1.textTransform;
});

exports.TitleH1Styled = TitleH1Styled;

var TitleH2Styled = _styledComponents.default.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH2.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH2.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH2.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH2.textTransform;
});

exports.TitleH2Styled = TitleH2Styled;

var TitleH3Styled = _styledComponents.default.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH3.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH3.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH3.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH3.textTransform;
});

exports.TitleH3Styled = TitleH3Styled;

var TitleOrangeBoldStyled = _styledComponents.default.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size:  ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n    border-bottom: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.colors.main;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || '17px';
}, function (props) {
  return props.fontWeight || 600;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin ? props.margin : '0px';
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH3.textTransform;
}, function (props) {
  return props.borderBottomBool && '1px solid #ddd';
});

exports.TitleOrangeBoldStyled = TitleOrangeBoldStyled;

var TitleH4Styled = _styledComponents.default.h4(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH4.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH4.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH4.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH4.textTransform;
});

exports.TitleH4Styled = TitleH4Styled;

var TitleH5Styled = _styledComponents.default.h5(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH5.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH5.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH5.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH5.textTransform;
});

exports.TitleH5Styled = TitleH5Styled;

var TitleH6Styled = _styledComponents.default.h6(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH6.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH6.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH6.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH6.textTransform;
});

exports.TitleH6Styled = TitleH6Styled;

var TitleH7Styled = _styledComponents.default.h6(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH7.fontColor;
}, function (props) {
  return props.customColor && props.customColor;
}, function (props) {
  return props.fontSize || props.theme.typography.titleH7.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.titleH7.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH7.textTransform;
});

exports.TitleH7Styled = TitleH7Styled;

var StrapLineStyled = _styledComponents.default.h6(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.strapLine.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.strapLine.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.strapLine.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
});

exports.StrapLineStyled = StrapLineStyled;

var ParagraphStyled = _styledComponents.default.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    font-style: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.paragraph.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.paragraph.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.paragraph.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.fontStyle;
});

exports.ParagraphStyled = ParagraphStyled;

var Paragraph2Styled = _styledComponents.default.p(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.paragraph2.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.paragraph2.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.paragraph2.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin || props.theme.typography.paragraph2.margin;
}, function (props) {
  return props.cursor;
});

exports.Paragraph2Styled = Paragraph2Styled;
var ErrorParagraphStyled = (0, _styledComponents.default)(ParagraphStyled)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    height: ", ";\n    margin: ", ";\n    padding-top: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.colors.red100;
}, function (props) {
  return props.fontSize || props.theme.typography.errorParagraph.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.errorParagraph.fontWeight;
}, function (props) {
  return props.height || props.error ? '12px' : '0';
}, function (props) {
  return props.error ? '0 0 10px 0' : props.margin ? props.margin : '0';
}, function (props) {
  return props.paddingTop || '2px';
});
exports.ErrorParagraphStyled = ErrorParagraphStyled;

var CardTitleStyled = _styledComponents.default.h4(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.cardTitle.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.cardTitle.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.cardTitle.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.cardTitle.textTransform;
});

exports.CardTitleStyled = CardTitleStyled;

var CardStrapLineStyled = _styledComponents.default.h4(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.cardStrapLine.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.cardStrapLine.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.cardStrapLine.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
});

exports.CardStrapLineStyled = CardStrapLineStyled;

var ActionTitleStyled = _styledComponents.default.h4(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.actionTitle.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.actionTitle.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.actionTitle.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.textTransform || props.theme.typography.actionTitle.textTransform;
});

exports.ActionTitleStyled = ActionTitleStyled;

var InfoTextStyled = _styledComponents.default.h4(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n"])), function (props) {
  return props.theme.colors[props.color] || props.theme.typography.infoText.fontColor;
}, function (props) {
  return props.fontSize || props.theme.typography.infoText.fontSize;
}, function (props) {
  return props.fontWeight || props.theme.typography.infoText.fontWeight;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
});

exports.InfoTextStyled = InfoTextStyled;

var CardTitleSmallStyled = _styledComponents.default.h3(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    color: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: 1rem;\n    font-family: Lato;\n    font-weight: 400;\n    line-height: 1.5;\n"])), function (props) {
  return props.color || props.theme.typography.cardTitle.fontColor;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
});

exports.CardTitleSmallStyled = CardTitleSmallStyled;

var PageTitleStyled = _styledComponents.default.h2(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    width: ", ";\n    font-size: ", ";\n    margin: ", ";\n    color: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    margin: ", ";\n    cursor: ", ";\n    text-transform: ", ";\n"])), function (props) {
  return props.width || '100%';
}, function (props) {
  return props.fontSize || props.theme.typography.titleH2.fontSize;
}, function (props) {
  return props.margin || '0px 0px 12px 12px';
}, function (props) {
  return props.theme.colors[props.color] || props.theme.typography.titleH2.fontColor;
}, function (props) {
  return props.fontWeight || 400;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.cursor;
}, function (props) {
  return props.textTransform || props.theme.typography.titleH2.textTransform;
});

exports.PageTitleStyled = PageTitleStyled;